import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function verifyOTP(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/validate/otp?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.VERIFY_OTP_REQUEST, types.VERIFY_OTP_RECEIVE,{
                type: types.VERIFY_OTP_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetVerifyOTP = () => ({
    type: types.RESET_VERIFY_OTP,
    payload: null
});